import * as Common from '@/tenant/common';

export class StockTransfer extends Common.StateObject{
  constructor(){
    super('StockTransfer');
    this.binders.segmentOut = new Common.ModelBinder(Common.Segment);
    this.binders.warehouseOut = new Common.ModelBinder(Common.Counterpart);
    this.binders.segmentIn = new Common.ModelBinder(Common.Segment);
    this.binders.warehouseIn = new Common.ModelBinder(Common.Counterpart);
    this.workflowCode="stockTransfer";
    this.state = StockTransferStatus.PostWaiting;
    this.workflowStateId = StockTransferStatus.PostWaiting;
  }
  public get actionTooltip() {
    if (this.state == StockTransferStatus.PostWaiting)　return '在庫に反映させる場合は【確定】をクリックします。';
    else if (this.state == StockTransferStatus.Completed) return '内容を修正する場合は【確定取消】をクリックします。';     
    else return '';
  }  
  public stockTransferNo: string = '';
  public transferFlag: number = TransferTypes.Transfer;
  public pic: string = null;
  public refNo: string = null;
  public bookDate: Date = new Date().getCalendarDate();
  public segmentOutId: number = 0;
  public segmentOut: Common.Segment = null;
  public warehouseOutId: number = 0;
  public warehouseOut: Common.Counterpart = null;
  public segmentInId: number = 0;
  public segmentIn: Common.Segment = null;
  public warehouseInId: number = 0;
  public warehouseIn: Common.Counterpart = null;
  public description: string = ''
}

export enum StockTransferStatus
{
  PostWaiting = 1, // 確定待ち
  Completed = 2 // 完了
}

export enum TransferTypes
{
  None = 0,
  Assemble = 1,
  Divide = 2,
  Transfer = 3,
}

export class StockTransferQuery extends Common.LoadQuery {
  constructor(){
    super('StockTransferQuery',StockTransfer);
    this.sort = 'stockTransferNo';
  }

  public pic: string = '';
  public stockTransferNo: string = '';
  public transferFlag:TransferTypes = TransferTypes.None;
  public segmentOut: Common.Segment = null;
  public segmentIn: Common.Segment = null;
  public warehouseOut: Common.Counterpart = null;
  public warehouseIn: Common.Counterpart = null;
  // public assemblyName:string = '';
  public refNo: string = '';
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: StockTransferStatus = StockTransferStatus.PostWaiting;
  public holder: string = '';
}

export class GetStockTransferItemQuery extends Common.Query{
  constructor(){
    super('GetStockTransferItemQuery', new Common.ModelBinder(Common.StockTransferItem, true));
  }
  public stockTransferNo: string = '';
}